import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { checkAuthorization } from '../../../helpers';
import { message } from 'antd'

export const getAddCardDetail = createAsyncThunk('getCardStatistics',
    async (_, { dispatch, getState }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingAddCardDetail())
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };
        fetch(domainUrl + `/getClientDashboardStats`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(addcardDetailResponse(result))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(addcardDetailClear())
                message.error(error) 
            })
    }
)

const AddCardSlice = createSlice({
    name: 'cardapi',
    initialState: {
        data: null,
        loading: false,
    },
    reducers: {
        gettingAddCardDetail: state => {
            state.loading=true
            state.data=null
        },
        addcardDetailResponse: (state, action)=>{
            state.data= action.payload
            state.loading= false
        },
        addcardDetailClear: (state)=>{
            state.data= null
            state.loading= false
        },
    },
})
export const { 
    gettingAddCardDetail, addcardDetailResponse, addcardDetailClear,
} = AddCardSlice.actions;
export default AddCardSlice.reducer;